ixModuleRouting("impactx.rfq", {
    "/rfqlistoffer": {
        template: "<ixa-rfq-list-offer></ixa-rfq-list-offer>",
        templateUrl: "modules/rfq/templates/rfqlistoffer.html",
        controller: "RFQListOfferCtrl",
        controllerAs: "rfqListOfferCtrl",
        process: "RFQBuyer",
        workspace: "shop",
    },
    "/rfqlistopen": {
        template: "<ixa-rfq-list-open></ixa-rfq-list-open>",
        templateUrl: "modules/rfq/templates/rfqlistopen.html",
        controller: "RFQListOpenCtrl",
        controllerAs: "rfqListOpenCtrl",
        process: "RFQBuyer",
        workspace: "shop",
    },
    "/rfqlistprep": {
        template: "<ixa-rfq-list-prep></ixa-rfq-list-prep>",
        templateUrl: "modules/rfq/templates/rfqlistprep.html",
        controller: "RFQListPrepCtrl",
        controllerAs: "rfqListPrepCtrl",
        process: "RFQBuyer",
        workspace: "shop",
    },
    "/rfqlistclosed": {
        template: "<ixa-rfq-list-closed></ixa-rfq-list-closed>",
        templateUrl: "modules/rfq/templates/rfqlistclosed.html",
        controller: "RFQListClosedCtrl",
        controllerAs: "rfqListClosedCtrl",
        process: "RFQBuyer",
        workspace: "shop",
    },
    "/singlerfqbuyer/:rfqsId": {
        template: '<ixa-rfq-edit-buyer></ixa-rfq-edit-buyer>',
        templateUrl: "modules/rfq/templates/editrfq.html",
        process: "RFQBuyer",
        controller: "RFQEditBuyerCtrl",
        controllerAs: "rfqEditCtrl",
        workspace: "shop",
    },
    "/singlerfqsupplier/:rfqsId": {
        template: '<ixa-rfq-edit-supplier></ixa-rfq-edit-supplier>',
        templateUrl: "modules/rfq/templates/editrfq.html",
        process: "RFQSupplier",
        controller: "RFQEditSupplierCtrl",
        controllerAs: "rfqEditCtrl",
        workspace: "shop",
    },
    "/rfqlistopensupplier": {
        template: "<ixa-rfq-list-open-supplier></ixa-rfq-list-open-supplier>",
        templateUrl: "modules/rfq/templates/rfqlistopensupplier.html",
        process: "RFQSupplier",
        controller: "RFQListOpenSupplierCtrl",
        controllerAs: "rfqListOpenSupplierCtrl",
        workspace: "shop",
    },
    "/rfqlistclosedsupplier": {
        template: "<ixa-rfq-list-closed-supplier></ixa-rfq-list-closed-supplier>",
        templateUrl: "modules/rfq/templates/rfqlistclosedsupplier.html",
        process: "RFQSupplier",
        controller: "RFQListClosedSupplierCtrl",
        controllerAs: "rfqListClosedSupplierCtrl",
        workspace: "shop",
    },
});
